"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateThemesTokenDataGroups = void 0;
var fs_1 = __importDefault(require("fs"));
var path_1 = __importDefault(require("path"));
var index_1 = require("../index");
var generateThemesTokenDataGroups = function (themesFolder, themesInclude) {
    if (!fs_1.default.existsSync(themesFolder)) {
        return {};
    }
    var themes = fs_1.default
        .readdirSync(themesFolder, { withFileTypes: true })
        .filter(function (item) { return item.isFile() && path_1.default.extname(path_1.default.join(themesFolder, item.name)) === '.json'; })
        .filter(function (item) {
        return path_1.default.parse(item.name).name === 'default' ||
            !(themesInclude === null || themesInclude === void 0 ? void 0 : themesInclude.length) ||
            (themesInclude === null || themesInclude === void 0 ? void 0 : themesInclude.find(function (name) { return name === path_1.default.parse(item.name).name; }));
    })
        .reduce(function (colorSchemas, item) {
        var fileContent = fs_1.default.readFileSync(path_1.default.join(themesFolder, item.name), 'utf-8');
        var themeTokens = (0, index_1.getThemeTokenDataGroups)(JSON.parse(fileContent));
        return __assign(__assign({}, colorSchemas), themeTokens);
    }, {});
    return (0, index_1.getThemesWithRestoredColors)(themes);
};
exports.generateThemesTokenDataGroups = generateThemesTokenDataGroups;
//# sourceMappingURL=generateThemesTokenDataGroups.js.map